import Vue from 'vue'
import App from './App'
import store from './store'


// 组件库样式
import '@/styles/main.css'

window.Vue = Vue
// 全局引入
// Vue.use(UifNext)
Vue.use(window.uif.default)


Vue.config.productionTip = false
// import '@/permission' // permission control

new Vue({
  el: '#app',
  store,
  render: h => h(App)
})
